import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { SetPopupReducerData } from "../../../store/reducer/PopupReducer";
import Customform from "../../../ui/custom-form";
import CustomInput from "../../../ui/custom-input";
import {
  AddCameraApi,
  fetchCameralistingApiId,
  fetchCameraTypeApi,
  GetDetailByCameraType,
  GetDeviceById,
  upadteCameraApi,
} from "../../../api/api";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { PulseLoader } from "react-spinners";
import CustomButton from "../../../ui/custom-button";

function AddCamera() {
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [cameraTypeInfo, setCameraTypeInfo] = useState([]);
  const [deviceData, setDeviceData] = useState([]);
  //console.log("deviceData", deviceData);
  const [loading, setLoading] = useState(false);
  const [highlightedFields, setHighlightedFields] = useState([]);
  const { data } = useSelector((state) => state?.PopupReducer?.modal || {});
  console.log("data>>>>>>>", data);
  const { user_id, organization_id } = useSelector(
    (state) => state?.authUser?.data?.data
  );
  const [inputData, setInputData] = useState({
    camera_type_id: "",
    camera_name: "",
    user_name: "",
    password: "",
    public_static_ip: "",
    rtsp_port: "",
    no_of_channels: "",
    location: "",
    is_audio_enabled: "",
    camera_url: "",
    rtsp_url: "",
    channel_port: "",
    device_id: "",
    user_id,
    organization_id,
  });
  //console.log("inputData", inputData);

  const fetchDetail = async () => {
    try {
      const res = await fetchCameralistingApiId(data, user_id, organization_id);
      const fetched = res?.data?.data;
      console.log("fetched", fetched);
      if (fetched) {
        setInputData({
          camera_type_id: fetched.camera_type_id || "",
          camera_name: fetched.camera_name || "",
          user_name: fetched.user_name || "",
          password: fetched.password || "",
          public_static_ip: fetched.public_static_ip || "",
          rtsp_port: fetched.rtsp_port || "",
          no_of_channels: fetched.no_of_channels || "",
          location: fetched.location || "",
          is_audio_enabled: fetched.is_audio_enabled || false,
          camera_url: fetched.camera_url || "",
          rtsp_url: fetched.rtsp_url || "",
          channel_port: fetched.channel_port || "",
          device_id: fetched.device_id || "",
        });
      }
    } catch (error) {
      //console.log("fetch camera detail error:", error);
    }
  };

  const fetchCameratype = async () => {
    try {
      const data = await fetchCameraTypeApi();
      if (data?.data?.status === true) {
        setCameraTypeInfo(data?.data?.data);
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  useEffect(() => {
    fetchCameratype();
  }, []);

  useEffect(() => {
    if (data) {
      fetchDetail();
    }
  }, [data]);

  const selectedCameraType = cameraTypeInfo?.find(
    (type) => type._id === inputData.camera_type_id
  );
  const isIPCamera = selectedCameraType?.camera_type_name === "IP Camera";

  const handleChange = (e) => {
    const { name, value, type } = e.target;
    const val =
      type === "radio"
        ? value === "true"
          ? true
          : value === "false"
          ? false
          : value
        : value;

    setInputData((prev) => ({
      ...prev,
      [name]: val,
    }));
  };

  const handleClose = () => {
    dispatch(
      SetPopupReducerData({
        modalType: "",
        showModal: false,
      })
    );
  };

  const handleGetDetail = async (id) => {
    try {
      const data = await GetDetailByCameraType(id,user_id,organization_id);
      //console.log("datadtail", data);
      if (data?.data?.status === true) {
        setDeviceData(data?.data?.data);
        setInputData((prev) => {
          return {
            ...prev,
            user_name: data?.data?.data[0]?.username,
          };
        });
      }
    } catch (error) {
      //console.log("error", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { ...inputData, user_id, organization_id };

      if (data) {
        payload.camera_id = data;

        const res = await upadteCameraApi(payload, data);
        if (res?.data?.status) {
          setLoading(false);
          handleClose();
        }
      } else {
        const res = await AddCameraApi(payload);
        if (res?.data?.status) {
          setLoading(false);
          handleClose();
        }
      }
    } catch (err) {
      console.error("Failed to save camera", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rightModal taskModal">
      <div className="modal-header p-3">
        {data ? (
          <h4 className="m-0">Update Camera</h4>
        ) : (
          <h4 className="m-0">Add Camera</h4>
        )}

        <button className="btnClose ms-auto" onClick={handleClose}>
          <IoCloseOutline />
        </button>
      </div>

      <div className="p-4 formBox formCstHeight">
        <Customform onSubmit={handleSubmit}>
          <div className="mb-3">
            <div className="form-label">Camera Type</div>
            <div className="d-flex gap-4 flex-wrap">
              {cameraTypeInfo?.map((type) => (
                <label
                  key={type._id}
                  className="d-flex align-items-center gap-1"
                >
                  <input
                    type="radio"
                    name="camera_type_id"
                    value={type._id}
                    checked={inputData.camera_type_id === type._id}
                    onChange={(e) => {
                      handleGetDetail(type._id);
                      setInputData((prev) => ({
                        ...prev,
                        camera_type_id: e.target.value,
                      }));
                    }}
                  />
                  {type.camera_type_name}
                </label>
              ))}
            </div>
          </div>

          <div className="col-12">
            <label className="form-label">Choose Device</label>
            <select
              value={inputData.device_id}
              name="device_id"
              onChange={async (e) => {
                const deviceId = e.target.value;

                setInputData((prev) => ({ ...prev, device_id: deviceId }));

                try {
                  const res = await GetDeviceById(deviceId);
                  const device = res?.data?.data;

                  if (device) {
                    setInputData((prev) => ({
                      ...prev,
                      device_id: deviceId,
                      user_name: device.username || "",
                      password: device.password || "",
                      public_static_ip: device.ip || "",
                      rtsp_port: device.port || "",
                    }));
                  }
                  setHighlightedFields([
                    "user_name",
                    "password",
                    "public_static_ip",
                    "rtsp_port",
                  ]);
                  setTimeout(() => {
                    setHighlightedFields([]);
                  }, 2000);
                } catch (error) {
                  console.error("Error fetching device detail:", error);
                }
              }}
              className="form-select"
            >
              <option value="">Select</option>
              {deviceData?.map((ele) => (
                <option key={ele._id} value={ele._id}>
                  {ele.device_name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label className="form-label mb-1">User Name</label>
            <CustomInput
              name="user_name"
              placeholder="Enter User Name"
              value={inputData.user_name}
              onChange={handleChange}
              className={
                highlightedFields.includes("user_name")
                  ? "highlighted-field"
                  : ""
              }
            />
          </div>

          <div className="mb-3">
            <label className="form-label mb-1">Password</label>
            <div className="position-relative">
              <CustomInput
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="**********"
                value={inputData.password}
                onChange={handleChange}
                className={
                  highlightedFields.includes("password")
                    ? "highlighted-field"
                    : ""
                }
              />
              <span
                className="position-absolute"
                style={{
                  top: "50%",
                  right: "10px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                  color: "#888",
                }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

          <div className="col-12">
            <label className="form-label">Public IP</label>
            <CustomInput
              name="public_static_ip"
              placeholder="Enter Static IP"
              value={inputData.public_static_ip}
              onChange={handleChange}
              className={
                highlightedFields.includes("public_static_ip")
                  ? "highlighted-field"
                  : ""
              }
            />
          </div>

          <div className="col-12">
            <label className="form-label">RTSP Port</label>
            <CustomInput
              name="rtsp_port"
              placeholder="Enter RTSP Port"
              value={inputData.rtsp_port}
              onChange={handleChange}
              className={
                highlightedFields.includes("rtsp_port")
                  ? "highlighted-field"
                  : ""
              }
            />
          </div>

          <div className="col-12">
            <label className="form-label">Name</label>
            <CustomInput
              name="camera_name"
              placeholder="E.g. Office Entry Gate"
              value={inputData.camera_name}
              onChange={handleChange}
            />
          </div>

          {!isIPCamera && (
            <div className="mb-3">
              <label className="form-label mb-1">No. of Channels</label>
              <select
                name="no_of_channels"
                className="form-select"
                value={inputData.no_of_channels}
                onChange={handleChange}
              >
                <option value="">Select</option>
                <option value="2">2</option>
                <option value="4">4</option>
                <option value="8">8</option>
                <option value="16">16</option>
                <option value="32">32</option>
              </select>
            </div>
          )}

          <div className="mb-3">
            <label className="form-label mb-1">Location</label>
            <select
              name="location"
              className="form-select"
              value={inputData.location}
              onChange={handleChange}
            >
              <option value="">Select</option>
              <option value="Main Office">Main Office</option>
              <option value="Floor 1">Floor 1</option>
              <option value="entry gate">Entry Gate</option>
              <option value="exit gate">Exit Gate</option>
              <option value="Floor 2">Floor 2</option>
              <option value="Confrence Room">Confrence Room</option>
              <option value="reception">Reception</option>
            </select>
          </div>

          {/* <div className="mb-3">
            <label className="form-label mb-1">Camera URL</label>
            <CustomInput
              name="camera_url"
              placeholder="Enter Camera URL"
              value={inputData.camera_url}
              onChange={handleChange}
            />
          </div> */}
          <div className="mb-3">
            <label className="form-label mb-1">Rtsp URL</label>
            <CustomInput
              name="rtsp_url"
              placeholder="Enter Rtsp URL"
              value={inputData.rtsp_url}
              onChange={handleChange}
            />
          </div>
          <div className="mb-3">
            <label className="form-label mb-1">Channel Port</label>
            <CustomInput
              name="channel_port"
              placeholder="Enter Channel Port"
              value={inputData.channel_port}
              onChange={handleChange}
            />
          </div>

          <div className="mt-3">
            <div className="form-label">Audio Enabled</div>
            <div className="d-flex gap-4">
              <label className="d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name="is_audio_enabled"
                  value="true"
                  checked={inputData.is_audio_enabled === true}
                  onChange={handleChange}
                />
                Yes
              </label>
              <label className="d-flex align-items-center gap-1">
                <input
                  type="radio"
                  name="is_audio_enabled"
                  value="false"
                  checked={inputData.is_audio_enabled === false}
                  onChange={handleChange}
                />
                No
              </label>
            </div>
          </div>

          {/* <div className="bottomBtn d-flex justify-content-between mt-4"> */}
          <div className="buttonGroup d-flex justify-content-between position-absolute start-0 bottom-0 w-100 p-4 border-top mt-5 bg-white">
            <button
              className="cancelBtn w-100"
              type="button"
              onClick={handleClose}
            >
              Cancel
            </button>
            {loading ? (
              <button type="submit" className="nextBtn w-100">
                <PulseLoader color="#fff" />
              </button>
            ) : (
              <button className="nextBtn w-100" type="submit">
                {data ? "Update" : "Submit"}
              </button>
            )}
          </div>
        </Customform>
      </div>
    </div>
  );
}

export default AddCamera;
